import React from "react";

const Button = ({
  children,
  variant = "solid", // solid, outline, ghost
  color = "main", // main, secondary, contrast
  size = "medium",
  className = "",
  ...props
}) => {
  const baseStyles = "rounded-md font-semibold transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main-darker ";

  const colors = {
    main: {
      bg: "bg-main",
      text: "text-white",
      hover: "hover:bg-main-dark",
      active: "active:bg-main-darker",
      border: "border-main",
      outlineText: "text-main",
    },
    secondary: {
      bg: "bg-secondary",
      text: "text-white",
      hover: "hover:bg-secondary-dark",
      active: "active:bg-secondary-darker",
      border: "border-secondary",
      outlineText: "text-secondary",
    },
    contrast: {
      bg: "bg-contrast-button",
      text: "text-white",
      hover: "hover:bg-contrast-dark",
      active: "active:bg-contrast-darker",
      border: "border-contrast",
    },
    whiteContrast: {
      bg: "bg-white",
      text: "text-contrast",
      hover: "hover:bg-white-dark",
      active: "active:bg-white-darker",
      border: "border-white",
      outlineText: "text-contrast",
    },
    white: {
      bg: "bg-white",
      text: "text-main",
      hover: "hover:bg-white hover:opacity-90",
      active: "active:bg-white active:opacity-80",
      border: "border-white",
      outlineText: "text-main",
    },

    contrastLight: {
      bg: "bg-contrast-light",
      text: "text-white",
      hover: "hover:bg-contrast-light hover:opacity-80",
      active: "active:bg-contrast-light active:opacity-90",
      border: "border-contrast-light",
      outlineText: "text-contrast-light",
    },

    mainDark: {
      bg: "bg-main-dark",
      text: "text-white",
      hover: "hover:bg-main-darker",
      active: "active:bg-main-darker",
      border: "border-main-dark",
      outlineText: "text-main-dark",
    },
  };

  const variants = {
    solid: `${colors[color].bg} ${colors[color].text} ${colors[color].hover} ${colors[color].active}`,
    outline: `border-2 ${colors[color].border} ${colors[color].outlineText} hover:${colors[color].bg} hover:text-white active:bg-opacity-90`,
    ghost: `${colors[color].text} hover:bg-gray active:bg-gray-dark`,
  };

  const sizes = {
    small: "px-3 py-1.5 text-sm",
    medium: "px-4 py-2 text-base",
    large: "px-8 py-2 text-lg",
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
